import { BrandAsset, Divider, Stack, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import Cookies from "js-cookie";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LoginDomainCard } from "./components/LoginDomainCard";
import { OtherServicesCard } from "./components/OtherServicesCard";
import { PlatformCards } from "./components/PlatformCards";
import { WelcomeBackHeading } from "./components/WelcomeBackHeading";

export function LoginPage() {
  const { t } = useTranslation();

  const lastSession = useMemo(() => {
    const lastLoggedIn = Cookies.get("last_logged_in");
    const domain = Cookies.get("last_logged_domain");

    if (domain?.includes("Legacy")) {
      Cookies.remove("last_known_name");
      return {
        lastLoggedIn,
        domain,
        email: Cookies.get("last_known_email_used"),
      };
    }

    return {
      lastLoggedIn,
      domain,
      email: Cookies.get("last_known_email_used"),
      name: Cookies.get("last_known_name"),
    };
  }, []);

  return (
    <Stack className={styles.container}>
      <Stack
        justify="space-between"
        align="center"
        gap="space-6"
        className={styles.stack}
      >
        <BrandAsset brand="certn" type="logo" height="43.75" width="42" />
        {lastSession.domain && lastSession.lastLoggedIn && lastSession.email ? (
          <>
            <WelcomeBackHeading
              name={lastSession.name}
              domain={lastSession.domain}
              lastLoggedIn={lastSession.lastLoggedIn}
              email={lastSession.email}
            />

            <LoginDomainCard
              name={lastSession.name}
              email={lastSession.email}
              domain={lastSession.domain}
            />

            <div className={styles.div}>
              <Divider className={styles.divider} />
              <Text style="summary/group-header" color="text-base">
                {t("Log in to a different platform or account:")}
              </Text>
            </div>
          </>
        ) : (
          <Text align="center" style="form/page-title">
            {t("Choose the platform you'd like to log into:")}
          </Text>
        )}

        <PlatformCards />
        <OtherServicesCard />
      </Stack>
    </Stack>
  );
}

const styles = {
  divider: css({
    padding: "var(--space-4)",
    marginBottom: "var(--space-3)",
    backgroundColor: "var(--base-weak)",
  }),
  div: css({
    padding: "var(--space-4)",
    textAlign: "center",
  }),
  container: css({
    backgroundColor: "var(--surface-sunken)",
    padding: "var(--space-6)",
    margin: 0,
    "@media (max-width: 768px)": {
      backgroundColor: "var(--surface-base)",
      padding: 0,
    },
  }),
  stack: css({
    backgroundColor: "var(--surface-base)",
    borderRadius: "var(--border-radius-3)",
    boxShadow: "var(--shadow-deep)",
    padding: "var(--space-6)",
    maxWidth: "900px",
    margin: "0 auto",
    "@media (max-width: 992px)": {
      width: "90%",
    },
  }),
};
